<template>
  <div
    :class="[
      $style.header_toolbar,
      $style[config.css || ''],
      'header_toolbar_common',
    ]"
  >
    <div :class="$style.left_side" />

    <div :class="$style.right_side">
      <filter-button
        v-if="config.ui.includes('filter')"
        :show-refresh-button="!blockFilterRefresh"
        :style="{margin: '0 4px'}"
      />

      <div
        v-if="config.ui.includes('zoom')"
        :class="$style.btn_group"
      >
        <zoom-slider
          :value="zoom"
          @onChange="$emit('changeZoom', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import globalStore from '$$globalStore';
import zoomSlider from '../../header/include/zoomSlider.vue';
import filterButton from '../../filter/components/filterButton.vue';
import Filter from '../../filter/filter';

export default {
  components: {
    zoomSlider,
    filterButton,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    buttonColors: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    'changeZoom',
  ],
  data() {
    return {
      locales: __,
    };
  },
  computed: {
    blockFilterRefresh() {
      return Filter.blockFilterRefresh;
    },

    zoom() {
      return globalStore.getters['headerView/zoom'];
    },

  },
};
</script>

<style module src="../../header/less/toolbarView.less" lang="less"></style>
